import React, { FC } from 'react'
import CaseStudiesGridItem from 'src/components/sections/caseStudies/CaseStudiesGridItem'
import SectionHeader from 'src/components/ui/SectionHeader'
import { GLOBAL_PREVIEW_MODE } from 'src/helpers/preview'

export interface ISplitSectionWithIconsProps {
  translationContent: {
    subtitle: string
    icons: any[]
    firstPartOfTitle: string
    secondPartOfTitle: string
    sectionName: string
    ctaText?: string
    ctaLink?: string
    ctaVariant?: 'button' | 'link'
  }
  isPreview?: boolean
}

// No GapBox needed for grid layout

const placeholderImages = [
  '/images/placeholders/cases/garett-cover.webp',
  '/images/placeholders/cases/latin-dance-passion-cover.webp',
  '/images/placeholders/cases/football-rules-cover.webp',
  '/images/placeholders/cases/rosa-cover.webp',
  '/images/placeholders/cases/var-cover.webp',
  '/images/placeholders/cases/the-ifab-cover.webp',
  '/images/placeholders/cases/learning-cover.webp',
  '/images/placeholders/cases/adidas-cover.webp',
]

const placeholderSubtitles = [
  'Garett',
  'Latin Dance Passion',
  'The IFAB',
  'ROSA',
  'VAR Platform',
  'The IFAB',
  'e-Learning Platform',
  'Adidas',
]

const sportPreviewItems = [
  {
    image: { url: '/images/placeholders/cases/garett-cover.webp', alt: 'Garett' },
    firstPartOfTitle: 'activity tracking',
    secondPartOfTitle: 'smartwatch management app',
    subtitle: 'Garett',
    link: '/case-studies/garett',
  },
  {
    image: { url: '/images/placeholders/cases/latin-dance-passion-cover.webp', alt: 'Latin Dance Passion' },
    firstPartOfTitle: 'dancing',
    secondPartOfTitle: 'in sync',
    subtitle: 'Latin Dance Passion',
    link: '/case-studies/latin-dance-passion',
  },
]

const SplitSectionWithIcons: FC<ISplitSectionWithIconsProps> = ({
  translationContent: {
    subtitle,
    icons = [],
    firstPartOfTitle,
    secondPartOfTitle,
    sectionName,
    ctaText,
    ctaLink,
    ctaVariant,
  },
  isPreview,
}) => {
  const isPreviewMode = isPreview !== undefined ? isPreview : GLOBAL_PREVIEW_MODE

  const displayItems = isPreviewMode
    ? [...sportPreviewItems.filter((p) => !icons.some((i) => i.link === p.link)), ...icons]
    : icons

  return (
    <section
      data-name={sectionName}
      id={sectionName}
      className="container py-20 md:py-32 bg-transparent"
    >
      <div className="mb-16 md:mb-24">
        <SectionHeader
          subtitle={subtitle}
          titlePart1={firstPartOfTitle}
          titlePart2={secondPartOfTitle}
          ctaText={ctaText}
          ctaLink={ctaLink}
          ctaVariant={ctaVariant}
          isFullWidthDescription
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-x-12 gap-y-16">
        {displayItems.map((item, index) => {
          let span = ''
          const seqIndex = index % 4

          if (seqIndex === 0 || seqIndex === 3) {
            span = 'md:col-span-5'
          } else {
            span = 'md:col-span-7'
          }

          const itemImage = isPreviewMode
            ? { url: item.image?.url || placeholderImages[index % placeholderImages.length], alt: item.image?.alt || '' }
            : item.image

          const itemSubtitle = item.subtitle || (isPreviewMode ? placeholderSubtitles[index % placeholderSubtitles.length] : '')

          return (
            <CaseStudiesGridItem
              key={item.link}
              title={itemSubtitle}
              subtitle=""
              firstPartOfTitle={item.firstPartOfTitle}
              secondPartOfTitle={item.secondPartOfTitle}
              tags={[]}
              ctaLink={item.link}
              className={span}
              isFullWidth={false}
              image={itemImage}
              detailImage={item.detailImage}
            />
          )
        })}
      </div>
    </section>
  )
}


SplitSectionWithIcons.defaultProps = {
  isPreview: undefined,
}

export default SplitSectionWithIcons
